import { useCallback, useMemo } from 'react';
import type { PopupState as PopupStateProps } from 'material-ui-popup-state/hooks';
import { MoreHorizontalAnchor } from '@/components/presentation/Anchor';
import { FileActionsContextMenuPopper } from '@/components/Workspace.File/File.Actions.ContextMenu';
import { useGroupFeatures } from '@trinity/chat-components/containers/Chat/hooks.js';
import type { FileMenuItemsContextValue } from '@/containers/Workspace.File/Context';
import { FileMenuItemsContext } from '@/containers/Workspace.File/Context';
import { FileActionsContainer } from '@/containers/Workspace.File/FileMenuContainer';
import useWorkspaceFileState from '@/containers/Workspace.File.Preview/hooks/useWorkspaceFileState';
import styles from './style/Header.Actions.module.css';

export const FilePreviewContextMenu = () => {

  const { capabilities, file, object, transcript } = useWorkspaceFileState();
  const features = useGroupFeatures();
  const showMenu = features.uploadFiles;

  const menu: FileMenuItemsContextValue = useMemo(() => ({
    canChangeOwner: capabilities.canChangeOwner,
    canDelete: capabilities.canDelete,
    canDownload: capabilities.canDownload,
    canManageAccess: capabilities.canManageAccess,
    canMove: capabilities.canMove,
    canRename: capabilities.canRename,
    canTranscribe: false,
    canViewTranscript: !!transcript?.id,
    canImportTranscript: false,
  }), [
    capabilities,
    transcript?.id,
  ]);

  const renderAnchor = useCallback((state: PopupStateProps) => {
    return (
      <MoreHorizontalAnchor className={styles.menu} open={state.isOpen} />
    );
  }, []);

  if (!showMenu) {
    return null;
  }

  return (
    <FileMenuItemsContext.Provider value={menu}>
      <FileActionsContainer
        file={file}
        object={object}
        transcriptId={transcript?.id}>
        <FileActionsContextMenuPopper renderAnchor={renderAnchor} />
      </FileActionsContainer>
    </FileMenuItemsContext.Provider>
  );
};